export default __webpack_public_path__ + "static/media/tiggy.f24b4440.png";